export default {
  development: 'https://rss.apps.dev-secureserver.net',
  test: 'https://rss.apps.test-secureserver.net',
  local: 'https://rss.apps.dev-secureserver.net',
  production: 'https://rss.apps.secureserver.net'
};
